import React from "react";
import { SiMessage } from "./SiMessage";
import { t } from "../i18n";
import { If } from "./If";

export const SiFormError: React.FC<{
  errors?: string[];
  hasError?: boolean;
}> = ({ children, errors = [], hasError = false }) => {
  return (
    <If predicate={hasError || (errors && errors.length > 0)}>
      <SiMessage type="error">
        {children}

        {errors.map((error, index) => (
          <span key={index}>{t(error)}</span>
        ))}
      </SiMessage>
    </If>
  );
};
